import { addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CreateThemeTagType, ThemeTagType } from "../types";
import { ThemeTagTypeDB } from "./ThemeTagTypeDB";

export const createThemeTagType = async (
  themeTagType: CreateThemeTagType,
): Promise<ThemeTagType> => {
  const collectionRef = collection(db, "themeTagTypes");

  const themeTagTypeRef = await addDoc(collectionRef, themeTagType);

  const newThemeTagTypeSnapshot = await getDoc(themeTagTypeRef);

  const newThemeTagType = new ThemeTagTypeDB(newThemeTagTypeSnapshot);

  return newThemeTagType.toThemeTagType();
};
